export default __webpack_public_path__ + "assets/09b3ff1de882ee4ffbbd1ab0628c3c1a.jpg";